import { useEffect } from "react";
import { Outlet, useMatches } from "react-router-dom";
import type { UIMatch } from "react-router-dom";
import { RouteType } from "./constant";
import { useImmerAtom } from "jotai-immer";
import { coreAtom } from "@/core/state/root";
import { useGlobalEventGoftino } from "@/core/lib/goftino";

const InitRoot = () => {
  const matches = useMatches() as UIMatch<unknown, RouteType["meta"]>[];
  const [, setCoreState] = useImmerAtom(coreAtom);
  useGlobalEventGoftino();

  useEffect(() => {
    const last = matches.pop();
    if (last?.handle?.isPage === true) {
      setCoreState((draft) => {
        // eslint-disable-next-line no-param-reassign
        draft.lastVisitedUrlThatWasAPage = last.pathname;
      });
    }
  }, [matches, setCoreState]);

  return <Outlet />;
};

export default InitRoot;
